module.exports = __webpack_public_path__ + "static/media/marketplace.c0fafb1f.webp";